// extracted by mini-css-extract-plugin
module.exports = {"table":"table__2NhyG","table__cell":"table__cell__30Lg9","actor":"actor__1sGw2","loader":"loader__2YMRx"};